"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDesktopDeepLinkURL = exports.toWebDeepLinkURL = exports.fromSearchObject = exports.fromDeepLinkURL = exports.PORTAL_DESKTOP_SCHEME = void 0;
var query_string_1 = require("query-string");
var util_1 = require("../util");
var parsers_1 = require("./parsers");
var types_1 = require("./types");
exports.PORTAL_DESKTOP_SCHEME = 'ddportal';
function fromDeepLinkURL(deepLinkURL) {
    var queryString = extractQueryString(deepLinkURL);
    if (!queryString) {
        return;
    }
    try {
        var query = query_string_1.parse(queryString);
        var legacyDeepLink = tryParseLegacyQueryString(queryString, query);
        if (legacyDeepLink) {
            return legacyDeepLink;
        }
        var auth = parsers_1.extractAuthLink(query);
        var name_1 = util_1.tryGetValue(query.name);
        var extractFn = name_1 ? parsers_1.extractNavLinks.get(name_1) : null;
        if (extractFn == null) {
            return auth;
        }
        var link = extractFn(query);
        return auth == null
            ? link
            : __assign(__assign({}, auth), link);
    }
    catch (error) {
        console.log("Invalid URL, fail on  parse deep link. url: " + deepLinkURL, error);
    }
}
exports.fromDeepLinkURL = fromDeepLinkURL;
function fromSearchObject(input) {
    if (input == null || typeof input !== 'object') {
        return;
    }
    var oauth = parsers_1.extractOAuthLink(input);
    if (oauth != null) {
        return oauth;
    }
    var auth = parsers_1.extractAuthLink(input);
    var name = util_1.tryGetValue(input.name);
    var extractFn = name ? parsers_1.extractNavLinks.get(name) : null;
    if (extractFn == null) {
        return auth;
    }
    var link = extractFn(input);
    return auth == null
        ? link
        : __assign(__assign({}, auth), link);
}
exports.fromSearchObject = fromSearchObject;
exports.toWebDeepLinkURL = function (deepLink, baseUrl) {
    return util_1.withoutTrailingSlash(baseUrl) + "?" + query_string_1.stringify(deepLink);
};
exports.toDesktopDeepLinkURL = function (deepLink) {
    return exports.PORTAL_DESKTOP_SCHEME + "://" + query_string_1.stringify(deepLink);
};
function extractQueryString(deepLinkURL) {
    var portalDesktopLead = exports.PORTAL_DESKTOP_SCHEME + "://";
    if (deepLinkURL.startsWith(portalDesktopLead)) {
        return deepLinkURL.substring(portalDesktopLead.length);
    }
    return query_string_1.extract(deepLinkURL);
}
function tryParseLegacyQueryString(queryString, parsedQuery) {
    if (parsedQuery['learningid'] != null) {
        var page_id = util_1.tryGetValue(parsedQuery['learningid']);
        if (!page_id) {
            return;
        }
        return {
            name: "content_page" /* ContentPage */,
            page_id: page_id,
        };
    }
    else if (parsedQuery['ticketid'] != null) {
        var ticket_id = util_1.tryGetValue(parsedQuery['ticketid']);
        if (!ticket_id) {
            return;
        }
        return {
            name: "ticket" /* Ticket */,
            ticket_id: ticket_id,
        };
    }
    else if (queryString.startsWith('requestsupport')) {
        return {
            name: "support_options" /* SupportOptions */,
        };
    }
    else if (queryString.startsWith('mytickets')) {
        return {
            name: "ticket_list" /* TicketList */,
            state: types_1.TicketListStates.Open,
        };
    }
    else if (parsedQuery['invoiceid'] != null) {
        var invoice_id = util_1.tryGetValue(parsedQuery['invoiceid']);
        if (!invoice_id) {
            return;
        }
        return {
            name: "invoice" /* Invoice */,
            invoice_id: invoice_id,
        };
    }
    else if (parsedQuery['recommendationid'] != null) {
        var quote_id = util_1.tryGetValue(parsedQuery['recommendationid']);
        if (!quote_id) {
            return;
        }
        return {
            name: "quote" /* Quote */,
            quote_id: quote_id,
        };
    }
    return;
}
